import MarketplaceExtensionManager from '../features/marketplace/MarketplaceExtensionManager';

export default function MarketplaceBridgePage() {
  return (
    <div className="page">
      <header className="page-header">
        <h1>Pazar Yeri Veri Köprüsü</h1>
        <p>
          Trendyol Go, Getir ve Migros Yemek panellerini Chrome eklentisiyle restoranınıza bağlayın.
        </p>
      </header>

      <MarketplaceExtensionManager />
    </div>
  );
}
